"use strict";

const review = document.querySelector(
  '[id^="shopify-block-"][id$="__judge_me_reviews_preview_badge_bWFeFg"]'
);

if (review) {
  const clonedReview = review.cloneNode(true);

  const destination = document.querySelector("#review-destination");

  destination.appendChild(clonedReview);

  review.classList.add("forced-invisible");
}
